import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DOMService {
  constructor(@Inject(DOCUMENT) protected readonly document: Document) {}

  public afterTick(fn: () => void): void {
    setTimeout(fn, 0);
  }

  public disableBodyScroll(): void {
    this.document.body.classList.add('overflow-hidden');
  }

  public enableBodyScroll(): void {
    this.document.body.classList.remove('overflow-hidden');
  }
}
